<template>
  <div class="payFees">
    <van-sticky>
      <div
        class="payFeesNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">{{
          identityType == 1 ? "个人代理人缴费记录" : "企业代理人缴费记录"
        }}</span>
      </div>
    </van-sticky>
    <!-- 列表 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
        <template #finished>
          <div class="finishedTip">
            <div v-if="dataList.length == 0">
              <img src="./../../../assets/decoration/noData.png" alt="" />
              <p>暂无相关数据</p>
            </div>
            <div v-else>没有更多了</div>
          </div>
        </template>

        <div class="content">
          <div
            class="item"
            @click="toPayFeesDetails(item.order_sn)"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <div class="top">
              <span>{{ item.updated_at }}</span>
              <span v-if="item.status == 10">待缴费</span>
              <span v-if="item.status == -10">交易取消</span>
              <span
                v-if="
                  item.status == 20 &&
                  item.contract &&
                  item.contract.status >= 0 &&
                  item.contract.status != 2
                "
                >已缴费，处理中</span
              >
              <span v-if="item.contract && item.contract.status == 2"
                >交易成功</span
              >
              <span v-if="item.status == 40">交易失败</span>
              <span v-if="item.status == -40">退款失败</span>
            </div>
            <div class="mid">
              <span>代理费</span>
              <span>-{{ item.amount }}</span>
            </div>
            <div class="btm waitPay" v-if="item.status == 10">
              <img src="./../../../assets/decoration/countDown.png" />
              <span>剩余{{ item.overdue_at | dataFormatting }}自动关闭</span>
            </div>
            <div
              class="btm seeHt"
              v-if="item.contract && item.contract.status == 2"
              @click.stop="seeContract(item.contract.contract_id)"
            >
              <img src="./../../../assets/decoration/contractBlue.png" />
              <span>查看合同</span>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      dataList: [],
      id: null,
      page: 1,
      pageSize: 10,
      loading: false,
      finished: true,
      refreshing: false,
      dateDown: null,
      identityType: 1,
    };
  },
  filters: {
    dataFormatting(value) {
      let val = Math.floor(value / 60) + "分" + Math.floor(value % 60) + "秒";
      return val;
    },
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
  },
  mounted() {
    this.getIdentityType();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 获取代理人当前身份
    getIdentityType() {
      this.$api.get("decoration/member/city/agent/switch/role").then((res) => {
        this.identityType = res.type;
        this.getAgentId();
      });
    },
    // 获取代理人id
    getAgentId() {
      this.$api
        .get("decoration/member/city/agent/show", {
          type: this.identityType,
        })
        .then((res) => {
          this.id = res.id;
          this.getData();
        });
    },
    getData() {
      this.loading = true;
      this.$api
        .post("decoration/member/agent/order/list", {
          id: this.id,
          pageSize: this.pageSize,
          page: this.page,
          type: this.identityType,
        })
        .then((res) => {
          // this.dataList = res.list;
          clearInterval(this.dateDown);
          this.dataList = this.dataList.concat(res.list);
          this.dataList.forEach((item) => {
            if (item.status == 10) {
              this.dateCountDown(item);
            }
          });
          this.loaded = true;
          this.refreshing = false;
          this.loading = false;
          if (this.dataList.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          } else {
            this.finished = false;
          }
        })
        .catch((err) => {
          this.refreshing = false;
          this.loading = false;
          this.finished = true;
        });
    },
    // 支付时间倒计时
    dateCountDown(item) {
      this.dateDown = setInterval(() => {
        if (item.overdue_at > 0) {
          item.overdue_at = item.overdue_at - 1;
        } else {
          clearInterval(this.dateDown);
        }
      }, 1000);
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.dataList = [];
      this.getData();
    },
    // 上拉加载
    onLoad() {
      this.page++;
      this.getData();
    },
    toPayFeesDetails(order_sn) {
      this.$router.push({
        path: "/decoration/deputy/payFeesDetails",
        query: {
          order_sn: order_sn,
        },
      });
    },
    seeContract(contract_id) {
      this.$router.push({
        path: "/decoration/deputy/seeContract",
        query: {
          contract_id: contract_id,
        },
      });
    },
  },
};
</script>
<style lang="less">
.payFees {
  min-height: 100%;
  background: #f2f2f2;
  .payFeesNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    margin: 0 16px;
    .item {
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      margin-top: 12px;
      .top {
        margin: 16px 16px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 13px;
          color: #999999;
          line-height: 18px;
        }
      }
      .mid {
        margin: 14px 16px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 14px;
          color: #333333;
          line-height: 20px;
        }
        span:last-child {
          font-weight: 700;
        }
      }
      .btm {
        height: 28px;
        width: 180px;
        border-radius: 2px 0px 0px 8px;
        padding: 0 16px;
        display: flex;
        align-items: center;
        img {
          width: 16px;
          height: 16px;
        }
        span {
          font-size: 12px;
          margin-left: 2px;
        }
      }
      .waitPay {
        background: linear-gradient(
          270deg,
          rgba(247, 104, 84, 0) 0%,
          rgba(247, 104, 84, 0) 0%,
          rgba(255, 126, 49, 0.3) 100%
        );
        span {
          color: #ff7e31;
        }
      }
      .seeHt {
        background: linear-gradient(
          270deg,
          rgba(247, 104, 84, 0) 0%,
          rgba(247, 104, 84, 0) 0%,
          rgba(146, 157, 255, 0.3) 100%
        );
        span {
          color: #5853e9;
        }
      }
    }
  }
}
.finishedTip {
  img {
    width: 149px;
    height: 125px;
    margin-top: 64px;
  }
}
</style>